import { SET_STORM_DATA } from '../actions/storm-map';

const initialState = {
  stormData: [],
};

const stormReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_STORM_DATA:
      return {
        ...state,
        stormData: action.payload,
      };

    default:
      return state;
  }
};

export default stormReducer;
